import { lazy } from 'react';

export const LandingHome = lazy(() => import("./LandingHome/index.page"));
export const Landingfaq = lazy(() => import("./Landingfaq/index.page"));
export const LandingCMS = lazy(() => import("./LandingCMS/index.page"));